import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, BreadcrumbGroup, Button, Container, Grid, Icon, Input, SpaceBetween, Spinner, StatusIndicator } from "@amzn/awsui-components-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { listFirstPassHistory } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus";
import { configureFSS3 } from "src/context/AuthContextUtility";
import { marked } from 'marked';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { convertToLocalTime } from "src/Ateam-BI/CorpReporting/Utility";
import FirstPassResultComponent from "./FirstPassResultComponent";
import { getResultContent } from "../Utility";


const FirstPassHistoryComponent = (props) => {
  const gridRef = useRef();
  const [entityList, setEntityList] = useState([]);
  const [quickFilterText, setQuickFilterText] = useState(null)
  const [viewResultsRequestDetails, setViewResultsRequestDetails] = useState(null)
  const [isLoading, setIsLoading] = useState(null);
  const [isResultsLoading, setIsResultsLoading] = useState(null);
  const [downloadLoader, setDownloadLoader] = useState({});
  const [downloadRichLoader, setDownloadRichLoader] = useState({});

  const defaultColDef = {
    // set filtering on for all columns
    filter: true,
    filterParams: {
      buttons: ['reset'],
      debounceMs: 200
    }
  };
  const columnDefs = useMemo(() => [
    { field: 'entity_code', headerName: 'Company Code', width: '160px', sortable: true, resizable: true },
    { field: 'entity_name', headerName: 'Entity Name', width: '250px', sortable: true, resizable: true },
    { field: 'current_year', headerName: 'Current Year', width: '150px', sortable: true, resizable: true },
    { field: 'previous_year', headerName: 'Prior Year', width: '150px', sortable: true, resizable: true },
    { field: 'invoke_method', headerName: 'Type Of Run', width: '150px', sortable: true, resizable: true },
    { field: 'execution_status', headerName: 'Status', width: '150px', sortable: true, resizable: true },
    {
      field: 'results',
      headerName: 'Results',
      width: '200px',
      sortable: true,
      resizable: true,
      cellRenderer: (params) => {
        const isLoading = downloadLoader?.[params?.data?.request_id];
        const isLoadingRichPdf = downloadRichLoader?.[params?.data?.request_id];

        return (
          <SpaceBetween direction="horizontal" size="s">
            <Button onClick={() => fetchDetails(params?.data)}>View</Button>
            <Button
              iconName="download"
              variant="icon"
              onClick={() => downloadResults(params?.data)}
              disabled={isLoadingRichPdf}
            />
            {/* <Button
              onClick={() => downloadResultsPlain(params?.data)}
              variant="inline-link"
              disabled={isLoading}
            >
              {isLoading ? 'Downloading...' : <SpaceBetween direction="horizontal" size="xxs">Plain pdf <Icon name="download" /></SpaceBetween>}
            </Button> */}
          </SpaceBetween>
        );
      }
    },
    { field: 'created_at', headerName: 'Execution Date', width: '250px', sortable: true, resizable: true, cellRenderer: (params) => {return params.value || ''}, valueGetter: (params) => { return params?.data?.created_at ? convertToLocalTime(params.data.created_at, true) : ''} },
    { field: 'request_id', headerName: 'ID', width: '150px', resizable: true, sortable: true },
  ], [downloadLoader, downloadRichLoader]);

  useEffect(() => {
    loadView()
  }, []);

  const loadView = () => {
    fetchAllHistory();
  }

  const downloadResults = async (data) => {
    setDownloadRichLoader(prev => ({ ...prev, [data.request_id]: true }));
    let mark = await getResultContent(data)
    downloadRichPdf(mark?.html, data)
  }

  const downloadResultsPlain = async (data) => {
    setDownloadLoader(prev => ({ ...prev, [data.request_id]: true }));
    let mark = await getResultContent(data)
    downloadPlainPdf(mark?.html, data)
  }

  const beautifyWrapper = (fullHtml, data) => {
    const formattedHtml = `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <title>${data.entity_name} ${data.current_year}</title>
    <style>
      /* Page Setup */
      @page {
        size: A4;
        margin: 10mm;
      }

      @media print {
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        /* Prevent elements from being cut off */
        h1, h2, h3, h4, h5, h6 {
          page-break-after: avoid;
          break-after: avoid;
        }

        p, li, blockquote {
          page-break-inside: avoid;
          break-inside: avoid;
        }

        /* Allow tables to break across pages */
        table {
          page-break-inside: auto;
          break-inside: auto;
        }

        tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }

        thead {
          display: table-header-group;
        }

        tfoot {
          display: table-footer-group;
        }

        /* Prevent orphans and widows */
        p {
          orphans: 3;
          widows: 3;
        }
      }

      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        margin: 0;
        padding: 15mm;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
        line-height: 1.5;
        color: #333;
        font-size: 11px; /* Smaller font for better fit */
      }

      /* Typography */
      h1 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #1a1a1a;
      }

      h2 {
        font-size: 16px;
        margin-top: 20px;
        margin-bottom: 10px;
        color: #2c3e50;
      }

      h3 {
        font-size: 14px;
        margin-top: 15px;
        margin-bottom: 8px;
        color: #34495e;
      }

      h4 {
        font-size: 12px;
        margin-top: 12px;
        margin-bottom: 6px;
      }

      p {
        margin-bottom: 10px;
      }

      /* Lists */
      ul, ol {
        margin: 10px 0 10px 20px;
      }

      li {
        margin-bottom: 4px;
      }

      /* Table Styles - KEY FIXES */
      table {
        border-collapse: collapse;
        width: 100%;
        margin: 15px 0;
        table-layout: fixed; /* Forces table to fit within width */
        font-size: 9px; /* Smaller font for tables */
      }

      th {
        padding: 4px 6px;
        border: 1px solid #ddd;
        background-color: #f5f5f5;
        text-align: left;
        font-weight: 600;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }

      td {
        padding: 4px 6px;
        border: 1px solid #ddd;
        text-align: left;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }

      tr {
        border-bottom: 1px solid #ddd;
      }

      tr:nth-child(even) {
        background-color: #fafafa;
      }

      /* Code */
      pre {
        background: #f6f8fa;
        padding: 10px;
        border-radius: 4px;
        overflow-x: auto;
        margin: 10px 0;
        border: 1px solid #e1e4e8;
        white-space: pre-wrap; /* Wrap long lines */
        word-wrap: break-word;
        font-size: 9px;
      }

      code {
        font-family: 'SF Mono', Consolas, 'Courier New', monospace;
        font-size: 9px;
        background: #f0f0f0;
        padding: 1px 4px;
        border-radius: 3px;
      }

      pre code {
        background: none;
        padding: 0;
      }

      /* Blockquote */
      blockquote {
        border-left: 3px solid #007bff;
        padding: 8px 15px;
        margin: 15px 0;
        background: #f8f9fa;
        color: #555;
      }

      /* Horizontal Rule */
      hr {
        border: none;
        border-top: 1px solid #ddd;
        margin: 20px 0;
      }

      /* Links */
      a {
        color: #007bff;
        text-decoration: none;
      }

      /* Images */
      img {
        max-width: 100%;
        height: auto;
      }

      /* Utility class for page breaks */
      .page-break {
        page-break-before: always;
        break-before: always;
      }
    </style>
  </head>
  <body>
    ${fullHtml}
  </body>
</html>
`;

    return formattedHtml;
  };

  const downloadRichPdf = (fullHtml, data) => {

    const formattedHtml = beautifyWrapper(fullHtml, data)

    // Create hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.style.visibility = 'hidden';

    document.body.appendChild(iframe);
    // Set content using srcdoc
    iframe.srcdoc = formattedHtml;

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setDownloadRichLoader(prev => ({ ...prev, [data.request_id]: false }));
        } catch (e) {
          console.error('Print error:', e);
        }

        // Remove iframe after print dialog closes
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 1000);
      }, 500);
    };
  }

  const downloadRichPdfNewWindow = (fullHtml, data) => {

    // Add CSS to hide browser headers/footers
    const formattedHtml = beautifyWrapper(fullHtml, data)

    const blob = new Blob([formattedHtml], { type: 'text/html;charset=utf-8' });
    const blobUrl = URL.createObjectURL(blob);
    const printWindow = window.open(blobUrl, '_blank');

    printWindow.addEventListener('load', () => {
      printWindow.print();
    });

    printWindow.addEventListener('afterprint', () => {
      URL.revokeObjectURL(blobUrl); // Cleanup
    });

  }

  const initPdfMake = async () => {
    try {
      const pdfFonts = await import("pdfmake/build/vfs_fonts");

      if (pdfFonts.pdfMake?.vfs) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      } else if (pdfFonts.default?.pdfMake?.vfs) {
        pdfMake.vfs = pdfFonts.default.pdfMake.vfs;
      } else if (pdfFonts.vfs) {
        pdfMake.vfs = pdfFonts.vfs;
      } else {
        console.error("Could not find vfs fonts");
      }
    } catch (error) {
      console.error("Error loading pdfMake fonts:", error);
    }
  };

  const downloadPlainPdf = async (fullHtml, data) => {
    await initPdfMake()
    // Convert HTML to pdfmake format - with selectable text. Issue is, it wont print special characters
    const pdfContent = htmlToPdfmake(fullHtml);

    const docDefinition = {
      content: pdfContent,
      defaultStyle: {
        fontSize: 12,
      },
      styles: {
        'html-th': {
          fillColor: '#f5f5f5',
          bold: true,
        },
      },
      pageSize: 'A4',
      pageMargins: [40, 40, 40, 40],
    };

    pdfMake.createPdf(docDefinition).download(`${data.entity_name}_${data.current_year}.pdf`);
    setIsResultsLoading(false)
    setDownloadLoader(prev => ({ ...prev, [data.request_id]: false }));
  }

  const fetchDetails = async (data) => {
    setViewResultsRequestDetails(data)
  }

  const fetchAllHistory = (nextToken = null, accumulatedItems = []) => {
    setIsLoading(true);

    listFirstPassHistory(
      100,
      nextToken,
      function onSuccess(response) {
        const items = response?.data?.listFirstPassHistory?.items || [];
        const newAccumulatedItems = [...accumulatedItems, ...items];
        const newNextToken = response?.data?.listFirstPassHistory?.nextToken;

        // If there's a nextToken, fetch more
        if (newNextToken) {
          fetchAllHistory(newNextToken, newAccumulatedItems);
          const sortedItems = newAccumulatedItems.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setEntityList(sortedItems);
          // setIsLoading(false);
        } else {
          // No more data, sort and set final list
          const sortedItems = newAccumulatedItems.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setEntityList(sortedItems);
          setIsLoading(false);
        }
      },
      function onFailure(error) {
        console.error('Error fetching entities:', error);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    onFilterTextBoxChanged()
    return () => {
      // this now gets called when the component unmounts
    };
  }, [quickFilterText]);

  function onFilterTextBoxChanged() {
    gridRef?.current?.api?.setGridOption(
      "quickFilterText",
      quickFilterText,
    );
  }


  return (
    <SpaceBetween direction="vertical" size="m">
      <BreadcrumbGroup
        items={[
          { text: "Dashboard", href: "/firstpass" },
          { text: "History", href: "/firstpass/history" },
        ]}
        ariaLabel="Breadcrumbs"
      />
      <Container>
        <SpaceBetween direction="vertical" size="m">
          <Grid
            gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          >
            <Input
              onChange={({ detail }) => setQuickFilterText(detail.value)}
              value={quickFilterText}
              expandToViewport={true}
              placeholder='Type to search'
            />

          </Grid>

          <div style={{
            width: '100%',
            height: '50vh',
          }}>

            <div
              className="ag-theme-alpine"
              style={{
                width: '100%',
                height: '100%',
                minHeight: '200px'
              }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={entityList}
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                rowSelection="single"
                animateRows={true}
                pagination={true}
                paginationPageSize={10}
                paginationPageSizeSelector={[10, 50, 100]}
                loading={isLoading}
              ></AgGridReact>
            </div>
          </div>
        </SpaceBetween>
      </Container>

      <FirstPassResultComponent data={viewResultsRequestDetails}>
      </FirstPassResultComponent>
    </SpaceBetween>

  );
};

export default FirstPassHistoryComponent;
